var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 27.8047C31.172 27.8047 34.25 24.7266 34.25 20.9297C34.25 17.1327 31.172 14.0547 27.375 14.0547C23.578 14.0547 20.5 17.1327 20.5 20.9297C20.5 24.7266 23.578 27.8047 27.375 27.8047Z",
    fill: "#00B3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8749 29.9219C32.4174 29.9219 30.4224 31.9169 30.4224 34.3744C30.4224 36.8319 32.4174 38.8281 34.8749 38.8281C37.3324 38.8281 39.3286 36.8319 39.3286 34.3744C39.3286 31.9169 37.3324 29.9219 34.8749 29.9219ZM34.8749 31.7969C36.2974 31.7969 37.4536 32.9519 37.4536 34.3744C37.4536 35.7969 36.2974 36.9531 34.8749 36.9531C33.4524 36.9531 32.2961 35.7969 32.2961 34.3744C32.2961 32.9519 33.4524 31.7969 34.8749 31.7969Z",
    fill: "#00B3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8125 30.8588V28.75C35.8125 28.2325 35.3925 27.8125 34.875 27.8125C34.3575 27.8125 33.9375 28.2325 33.9375 28.75V30.86C33.9375 31.3763 34.3575 31.7975 34.875 31.7975C35.3925 31.7963 35.8125 31.3763 35.8125 30.8588Z",
    fill: "#00B3FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0238 32.5521L39.5151 31.0596C39.8813 30.6946 39.8813 30.0996 39.5151 29.7346C39.1501 29.3684 38.5551 29.3684 38.1901 29.7346L36.6976 31.2259C36.3326 31.5921 36.3326 32.1859 36.6976 32.5521C37.0638 32.9171 37.6576 32.9171 38.0238 32.5521Z",
    fill: "#00B3FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3899 35.3125H40.4999C41.0174 35.3125 41.4374 34.8925 41.4374 34.375C41.4374 33.8575 41.0174 33.4375 40.4999 33.4375H38.3899C37.8736 33.4375 37.4536 33.8575 37.4536 34.375C37.4524 34.8925 37.8736 35.3125 38.3899 35.3125Z",
    fill: "#00B3FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6976 37.5238L38.1901 39.0151C38.5551 39.3813 39.1501 39.3813 39.5151 39.0151C39.8813 38.6501 39.8813 38.0551 39.5151 37.6901L38.0238 36.1976C37.6576 35.8326 37.0638 35.8326 36.6976 36.1976C36.3326 36.5638 36.3326 37.1576 36.6976 37.5238Z",
    fill: "#00B3FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9375 37.8896V39.9996C33.9375 40.5171 34.3575 40.9371 34.875 40.9371C35.3925 40.9371 35.8125 40.5171 35.8125 39.9996V37.8896C35.8125 37.3734 35.3925 36.9534 34.875 36.9521C34.3575 36.9521 33.9375 37.3734 33.9375 37.8896Z",
    fill: "#00B3FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7264 36.1976L30.2351 37.6901C29.8689 38.0551 29.8689 38.6501 30.2351 39.0151C30.6001 39.3813 31.1951 39.3813 31.5601 39.0151L33.0526 37.5238C33.4176 37.1576 33.4176 36.5638 33.0526 36.1976C32.6864 35.8326 32.0926 35.8326 31.7264 36.1976Z",
    fill: "#00B3FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3588 33.4375H29.25C28.7325 33.4375 28.3125 33.8575 28.3125 34.375C28.3125 34.8925 28.7325 35.3125 29.25 35.3125H31.3588C31.8763 35.3125 32.2975 34.8925 32.2963 34.375C32.2963 33.8575 31.8763 33.4375 31.3588 33.4375Z",
    fill: "#00B3FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0526 31.2259L31.5601 29.7346C31.1951 29.3684 30.6001 29.3684 30.2351 29.7346C29.8689 30.0996 29.8689 30.6946 30.2351 31.0596L31.7264 32.5521C32.0926 32.9171 32.6864 32.9171 33.0526 32.5521C33.4176 32.1859 33.4176 31.5921 33.0526 31.2259Z",
    fill: "#00B3FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.17 39.6943C28.5025 38.8368 28.5625 37.5931 29.3513 36.8056L29.5938 36.5618H29.25C28.0425 36.5618 27.0625 35.5818 27.0625 34.3743C27.0625 33.1668 28.0425 32.1868 29.25 32.1868H29.5938L29.3513 31.9431C28.5312 31.1243 28.4988 29.8131 29.2537 28.9543C28.6413 28.9068 28.0138 28.8818 27.375 28.8818C23.2225 28.8818 19.5462 29.9206 17.2638 31.4768C15.5225 32.6643 14.5625 34.1731 14.5625 35.7568V37.5693C14.5625 38.1331 14.7863 38.6743 15.185 39.0718C15.5838 39.4706 16.1238 39.6943 16.6875 39.6943H29.17Z",
    fill: "#00B3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans9);
export default __webpack_public_path__ + "static/media/trans9.bc7748c1ea1673c333b4435bd266bd79.svg";
export { ForwardRef as ReactComponent };